import { FC, useEffect } from "react";
import { IEventParticipant } from "../../../models/events.model";
import { AttendanceContents } from "../../../pages/event/attendance";
import Button from "../../Button";
import { useTranslation } from "react-i18next";

interface IProps {
  setContent: (content: AttendanceContents) => void;
  participant: IEventParticipant|undefined;
  type: string;
}

const Result: FC<IProps> = ({
  setContent,
  participant,
  type,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(() => {
      setContent(AttendanceContents.Input);
    }, 10000);
  }, []);

  return (
    <>
      <div className="box">
        <div className="flex flex-justify-center">
          <table className="table table-bordered">
            <tbody>
              <tr>
                <th>{t('event.attendance.2')}</th>
                <td>{participant?.memberKorName}</td>
              </tr>
              {type === 'ED' && (
                <tr>
                  <th>{t('event.attendance.3')}</th>
                  <td>{participant?.campusKorName}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="guide-text mt-4">
          {t('event.attendance.4')}
        </div>
        <div className="text-center mt-5">
          <Button
            className="btn confirm-button"
            onClick={() => setContent(AttendanceContents.Input)}
            text={t('common.button.confirm')}
          />
        </div>
      </div>
    </>
  );
}

export default Result;
